//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import "@/assets/css/reset.css";
import "@/assets/css/global.css";
export default {
  props: ["work_bench_item"],
  methods: {
    handleClick(item) {
        var userInfo = this.$appBox.getPassageUser();
      // console.log(userInfo.IsIndependentScore,item.text,"zzzzzz")
      if (userInfo) {
        if (
          (!userInfo.IsIndependentScore) &&
          (item.text == "帮积分" ||
            item.text == "帮兑换" ||
            item.text == "帮注册")
        ) {
          this.$dialog.alert({
            title: "提示",
            message: "仅限川渝地区开放"
          });
          return;
        }
      }
      if (item.blocked) {
        return this.$dialog.alert({
          title: "提示",
          message: item.msg
        });
      }
      if (item.link) {
        // wx.navigateTo({ url: item.link })
        if (item.link.indexOf("http") == -1) {
          this.$router.push(item.link);
        } else {
          window.location = item.link;
          this.$msg.loading();
        }
      }
      if (item.action) {
        this.$emit(item.action);
      }
    }
  }
};
